import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Education = () => {

  const [showModal, setShowModal] = useState(false);
  const [certificateUrl, setCertificateUrl] = useState('');
  const location = useLocation();

  useEffect(() => {
    if(location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      } 
    }
  }, [location]);

  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  function resetCursor() {
    const allDots = document.querySelectorAll(
      ".cursor-dot, .cursor-dot1, .cursor-dot2, .cursor-dot3, .cursor-dot4, .cursor-dot5"
    );
    const blinkDot = document.querySelector(".cursor-blink");
    allDots.forEach(dot => dot.style.display = "block");
    blinkDot.style.display = "none";
  }

  const openModal = (url) => {
    setCertificateUrl(url);
    setShowModal(true);
  }

  const closeModal = () => {
    setShowModal(false);
    setCertificateUrl('');
    resetCursor();
  }

  return (
    <section className="section" id="education">
      <div className="container text-center">
        <p className="section-subtitle" data-aos="fade-up">My Journey</p>
        <h6 className="section-title mb-6" data-aos="fade-up">Education & Certifications</h6>

        <div className="education-grid row mx-auto">
          <div className="edu-card col-md-5 m-2" data-aos="fade-up">
            <h6 className="font-weight-bold">12th (PCM)</h6>
            <p className="mb-1">MP Board | 2022</p>
            <p className="text-muted">Scored 78% in Physics, Chemistry & Math</p>
          </div>

          <div className="edu-card col-md-5 m-2" data-aos="fade-up" data-aos-delay="100">
            <h6 className="font-weight-bold">B.Tech in Computer Science</h6>
            <p className="mb-1">SGSITS, Ujjain | 2022 - 2026</p>
            <p className="text-muted">Final Semester Completed (Result Awaited)</p>
          </div>

          <div className="edu-card col-md-5 m-2" data-aos="fade-up" data-aos-delay="200">
            <h6 className="font-weight-bold">MERN Stack Development</h6>
            <p className="mb-1">Skilledu | 2024</p>
            <p className="text-muted">MongoDB, Express.js, React.js, Node.js</p>
            <button
              className="btn btn-primary rounded-pill education-btn px-3"
              onClick={() => openModal('/certificates/MERN_Certificate_Tehzeeb.jpg')}
            >
              View Certificate
            </button>
          </div>

          <div className="edu-card col-md-5 m-2" data-aos="fade-up" data-aos-delay="300">
            <h6 className="font-weight-bold">Internship (Web Developer)</h6>
            <p className="mb-1">Geektheory | 2025</p>
            <p className="text-muted">Working on real client projects using MERN stack</p>
            <button
              className="btn btn-primary rounded-pill education-btn px-3"
              onClick={() => openModal('/certificates/Internship_Certificate_Tehzeeb.jpg')}
            >
              View Certificate
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <div className='modal-overlay' onClick={closeModal}>
          <div className='modal-content' onClick={(e) => e.stopPropagation()}>
              <div className='modal-head m-4'>
              <h1 className='section-title'>Certificate</h1>
              <button className='close-button' onClick={closeModal}>&times;</button>
            </div>
            <div className='modal-img'>
              <center>
                <img 
                  src={certificateUrl}
                  alt="Certificate"
                />
              </center>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Education;
